$(document).ready(function(){
    $(".quantity-increase").click(function () {
      $(".quantity-total").val(parseInt($(".quantity-total").val()) + 1);

    });

    $(".quantity-decrease").click(function () {
      var currentValue = parseInt($(".quantity-total").val());
      if (currentValue > 1) {
        $(".quantity-total").val(currentValue - 1);
      }
    });
})